import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Button } from 'react-native-elements';
import { Auth } from 'aws-amplify';
import IconTextInput from './IconTextInput';
import ModalTokenInput from './ModalTokenInput';
import Wrapper from '../Wrapper';

const styles = StyleSheet.create({
    buttonsContainer: {
        display: 'flex',
        flexDirection: 'row'
    },
    errorContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    error: {
        backgroundColor: 'red',
        color: 'white',
        alignSelf: 'center',
        paddingLeft: 8,
        paddingRight: 8
    },
    flexGrow: {
        flex: 1
    },
    signInForm: {
        marginLeft: '10%',
        marginRight: '10%'
    },
    signInFormContainer: {
        width: '100%'
    }
});

class SignIn extends React.Component {
    static defaultProps = {
        authData: {},
        authState: 'signIn',
        onAuthStateChange: (next, data) => { console.log(`SignIn:onAuthStateChange(${next}, ${JSON.stringify(data, null, 2)})`); }
    };

    constructor(props) {
        super(props);
        this.state = {
            authData: this.props.authData,
            authState: this.props.authState,
            modalShowing: false,
            loading: false,
            error: null,
            username: this.props.authData.username || '',
            password: this.props.authData.password || '',
            api_authorization: this.props.authData.api_authorization,
        };
    }

    async onSignIn() {
        this.setState({ loading: true });
        try {
            const user = await Auth.signIn(this.state.username, this.state.password);
            this.setState({api_authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`});
            console.log(`onSignIn::Response#1: ${JSON.stringify(user, null, 2)}`);

            // If the user session is not null, then we are authenticated
            if (user.signInUserSession == null) {
				// Anything else and there is a problem
	            throw new Error('Invalid response from server');
            }

            this.props.onAuthStateChange('authenticated', { username: this.state.username, api_authorization: this.state.api_authorization });
        } catch (err) {
            console.log(`Error: ${JSON.stringify(err, null, 2)}`);
            this.setState({ error: err.message, loading: false });
        }
    }

    render() {
        let settings = {
            signUpButton: {
                title: 'Sign Up',
                backgroundColor: '#397af8',
                fontSize: 14,
                containerViewStyle: { flex: 1 },
                enabled: !this.state.loading,
                onPress: () => this.props.onAuthStateChange('signUp', {})
            },
            forgotPasswordButton: {
                title: 'Reset Password',
                backgroundColor: '#4d86f7',
                fontSize: 14,
                containerViewStyle: { flex: 1 },
                enabled: !this.state.loading,
                onPress: () => this.props.onAuthStateChange('forgotPassword', {})
            },
            usernameInput: {
                iconColor: '#424242',
                iconName: 'user',
                iconSize: 24,
                autoCapitalize: 'none',
                autoCorrect: false,
                autoFocus: true,
                returnKeyType: 'next',
                placeholder: 'Username',
                placeholderTextColor: '#404040',
                value: this.state.username,
                onChangeText: (text) => this.setState({ username: text.toLowerCase() })
            },
            passwordInput: {
                iconColor: '#424242',
                iconName: 'lock',
                iconSize: 24,
                autoCapitalize: 'none',
                autoCorrect: false,
                returnKeyType: 'done',
                secureTextEntry: true,
                placeholder: 'Password',
                placeholderTextColor: '#404040',
                value: this.state.password,
                onChangeText: (text) => this.setState({ password: text })
            },
            submitButton: {
                title: 'Sign In',
                backgroundColor: '#397af8',
                onPress: () => this.onSignIn(this.state.username, this.state.password)
            },
            submitButtonLoading: {
                icon: {
                    color: 'white',
                    name: 'refresh',
                    size: 24,
                    type: 'font-awesome'
                },
                backgroundColor: '#cccccc',
                title: 'Signing In...'
            }
        };

        const errorComponent = this.state.error !== null
            ? <View style={styles.errorContainer}><Text style={styles.error}>{this.state.error}</Text></View>
            : false;

        return (
            <Wrapper>
                {this.state.error !== null && errorComponent}
                <View style={styles.signInForm}>
                    <View style={styles.signInFormContainer}>
                        <IconTextInput {...settings.usernameInput}/>
                        <IconTextInput {...settings.passwordInput}/>
                        <View style={styles.signInFormButtons}>
                            <Button {...(this.state.loading ? settings.submitButtonLoading : settings.submitButton)}/>
                        </View>
                    </View>
                </View>
                <View style={styles.flexGrow}/>
                <View style={styles.buttonsContainer}>
                    <Button {...settings.signUpButton}/>
                    <Button {...settings.forgotPasswordButton}/>
                </View>
            </Wrapper>
        );
    }
}

export default SignIn;